import type { SbBlokData } from "@storyblok/react/rsc";
import { storyblokEditable } from "@storyblok/react/rsc";

import { Heading } from "@/components/atoms";
import ClientStoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/ClientStoryblokComponent";
import isEmptyRichText from "@/lib/utils/isRichTextEmpty";
import type { SlimHeroStoryblok } from "@/types/storyblok-blok-types";
import RichTitle from "../RichTitle/RichTitle";
import styles from "./slimHero.module.css";

const SlimHero = ({
  blok,
  preview,
}: {
  blok: SlimHeroStoryblok;
  preview?: boolean;
}) => {
  const { title, media, darkText } = blok;

  const fontColor = darkText
    ? { color: "black" }
    : { color: "var(--color-base)" };

  const Title = () =>
    !isEmptyRichText(title) ? null : (
      <div className="hero-title">
        <Heading
          as={"h2"}
          styledAs={"h4"}
          className={styles.heading}
          style={fontColor}
        >
          <RichTitle>{title}</RichTitle>
        </Heading>
      </div>
    );
  return (
    <div
      {...storyblokEditable(blok as unknown as SbBlokData)}
      className={styles.slimHero}
    >
      {/* Background Image */}
      {media && media.length > 0 && (
        <div className={styles.imageWrapper}>
          {media.map((img) => (
            <ClientStoryblokComponent
              key={img._uid}
              blok={img}
              preview={preview}
            />
          ))}
        </div>
      )}

      {/* Content */}

      <div className={styles.content}>
        <Title />
      </div>
    </div>
  );
};

export default SlimHero;
